export default __webpack_public_path__ + "static/media/icon-agent-hands-up-raised.fb71974f.svg";